// TODO: REMOVE
import { auto } from '@popperjs/core';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import SliderPlugin from './slider-plugin';
Swiper.use([Navigation, Pagination]);

class AOISlider extends SliderPlugin  {

    static type: String = "aoi-image-bg-slider"

    constructor(element: HTMLElement) {
        super(element);
    }

    init() {
        let buttons = this.getButtons();
        this.swiper = new Swiper(this.getClassPath(), {
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            spaceBetween: 0,
            speed: 100,
            loop: false,
            loopFillGroupWithBlank: false,
            pagination: false,
            navigation: {
                nextEl: buttons.nextBtn,
                prevEl: buttons.prevBtn,
            },
            breakpoints: {
                576: {
                    slidesPerView: 'auto',
                    slidesPerGroup: 2,
                    speed: 300,
                    spaceBetween: 0,
                },
                /*768: {
                    slidesPerView: 3,
                    slidesPerGroup: 1,
                    spaceBetween: 5,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 0,
                },
                1200: {
                    slidesPerView: 5,
                    spaceBetween: 0,
                }*/
            },
        });

        this.swiper.on('slideChange', function () {
            window.lazyload.update();
        });
    }
}

export default AOISlider;